<div style="max-width:800px" *ngIf="data && data.length>0">
  <table class="table">
    <thead class="thead-light">
      <tr>
        <th>
          Equipment
        </th>
        <th>
          Quantity
        </th>
        <th>
          Comments
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of data">
        <td>
          {{item?.EquipmentIdDisplay}}
        </td>
        <td>
          {{item?.Quantity}}
        </td>
        <td>
          {{item?.Comments}}
        </td>
      </tr>
    </tbody>

  </table>
</div>

<div style="max-width:800px" *ngIf="!data || data.length==0">
  There are no equipment items
</div>
